<template>
  <header class="header">
    <div class="centent">
      <div class="logo">
        <div class="left">
          <img class="imgLogo" src="../../../../static/image/home/logo.png" alt="" />
          <div class="title">
            <div class="headline" :style="isHomePage ? { color: '#000' } : {}">
              {{ title }}
            </div>
            <div class="subtitle" :style="isHomePage ? { color: '#000' } : {}">
              {{ subtitle }}
            </div>
          </div>
        </div>
        <div>
          <div class="right" v-if="isLogin">
            <ul>
              <li class="login" @click="toLogin">登录</li>
              <li class="register" @click="toRegister">注册</li>
            </ul>
          </div>

          <div class="topdo-right" v-else>
            <ul class="topdo-right-ul">
              <li>
                <span class="li-img" title="基本信息">
                  <Dropdown trigger="hover" style="z-index: 1001">
                    <a
                      href="javascript:void(0)"
                      style="display: flex; align-items: center; color: #000"
                    >
                      <img
                        class="UserImgCal"
                        style="margin-right: 1rem"
                        :src="userImg ? userImg : '../../../static/img/user_head_portrait.png'"
                        alt=""
                      />
                      欢迎您: {{ username }}
                    </a>
                    <DropdownMenu slot="list">
                      <DropdownItem name="editcode">
                        <div @click="changepassOpt">修改密码</div>
                      </DropdownItem>

                      <DropdownItem name="desc" @click.native="showDesc = true"
                        >登录信息</DropdownItem
                      >
                      <DropdownItem name="apply" @click.native="toShowApplyHistory"
                        >申请记录</DropdownItem
                      >
                      <DropdownItem name="exitLogin" @click.native="Logout()">
                        <div>退出登录</div>
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </span>
              </li>
              <li></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="menu">
      <!-- tab组件 -->
      <Menu
        mode="horizontal"
        class="menuHeader"
        :active-name="actName"
        :theme="theme1"
        @on-select="itemSelect"
      >
        <div class="menuDiv" v-for="(menu, indexMenu) in menuData2" :key="indexMenu">
          <Submenu class="menuParent" v-if="menu.childtool" :name="menu.id">
            <div slot="title" class="menuContent">
              {{ menu.name }}
            </div>
            <div>
              <template v-for="(weight, wIndex) in menu.childtool">
                <MenuItem
                  v-if="weight.id"
                  :name="weight.id"
                  :key="wIndex"
                  :disabled="weight.disabled"
                >
                  <div class="menuItem">
                    <!-- <img class="menuItemImg" :src="weight.imageUrl" /> -->
                    <!-- <img class="menuItemImgHover" :src="weight.hoverImage" /> -->
                    <span>{{ weight.name }}</span>
                  </div>
                </MenuItem>
              </template>
            </div>
          </Submenu>
          <MenuItem class="menuParent" v-else :name="menu.id">
            <div
              class="menuContent"
              :style="
                activitiHeaderName == menu.id
                  ? {
                      background: '#1484f2',
                      color: '#fff',
                      padding: '0 1rem',
                      borderRadius: '6px',
                    }
                  : {}
              "
            >
              <!-- <img class="img" :src="menu.imageUrl" /> -->
              <!-- <img class="imgHover" :src="menu.hoverImage" /> -->
              <span> {{ menu.name }} </span>
            </div>
          </MenuItem>
        </div>
      </Menu>
    </div>
  </header>
</template>

<script>
import Header from './outher.js';
export default Header;
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  overflow-y: auto;
  overflow-x: auto;
  .centent {
    padding: 0 10.6rem;
    background-image: url(http://60.13.8.238:7701/static/img/nohomeBG.050e8ed.png);
    background-position: center;
    background-size: 100%;
    background-repeat: no-repeat;
  }
  .header {
    z-index: 9;
    // width: 1412px;
    width: 100%;
    background-color: #fff;
    color: #fff;
    height: 14.3rem;

    background-position: top;
    background-size: 100%;
    background-repeat: no-repeat;
    .logo {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 8.1rem;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .left {
        display: flex;
        align-items: center;
        // margin-left: 5rem;
        .imgLogo {
          height: 4.2rem;
          width: 8.5rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .title {
          color: #000;
          margin-left: 0.8rem;
          .headline {
            letter-spacing: 2px;
            font-size: 2.8rem;
            font-weight: 600;
            color: #000;
            span {
              font-size: 1.6rem;
              font-weight: 550;
              color: #000;
              margin-left: 1rem;
              letter-spacing: 1px;
            }
          }
          .subtitle {
            font-size: 1.2rem;
            font-weight: normal;
            color: #000;
          }
        }
        .desc {
          display: flex;
          align-items: center;
          .title {
            font-size: 30px;
            font-weight: bold;
          }
          .text {
            font-size: 14px;
            margin-left: 12px;
            color: rgba(255, 255, 255, 0.9);
            position: relative;
            bottom: -7px;
            right: 0;
          }
        }
        .eng {
          height: 14px;
        }
      }

      .right {
        display: flex;
        .help {
          display: flex;
          align-items: center;
          margin-right: 20px;
          cursor: pointer;
          font-size: 20px;
          &::before {
            display: inline-block;
            vertical-align: middle;
            content: '?';
            height: 18px;
            width: 18px;
            border-radius: 50%;
            background-color: #174676;
            color: #00295b;
            text-align: center;
            line-height: 19px;
            margin-right: 6px;
          }
        }
        ul {
          display: flex;
          align-items: center;
          font-size: 1.8rem;
          letter-spacing: 2px;
          li {
            cursor: pointer;
          }
          .login {
            margin-right: 1.5rem;
            font-size: 2rem;
            color: #000;
          }
          .register {
            border-radius: 4px;
            width: 9rem;
            height: 3.2rem;
            text-align: center;
            line-height: 3rem;
            font-size: 2rem;
            border: 1px solid #000;
            color: #000;
          }
        }
      }
    }
    .menuHeader {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: transparent;
      background-color: rgb(19, 83, 200);
      height: 6rem;
      .menuDiv {
        min-width: 16rem;
        display: flex;
        justify-content: center;
        height: 6rem;
        .menuParent {
          display: flex;
          position: relative;
          justify-content: center;
          align-items: center;
          width: 100%;
          border: none;
          padding: 0;
          color: #fff;
          /deep/ .ivu-menu-submenu-title {
            display: flex;
            align-items: center;
          }
          /deep/ .ivu-select-dropdown {
            min-width: 0 !important;
          }
          .menuContent {
            display: flex;
            align-items: center;
            font-size: 2rem;
            font-weight: 400;
            color: #fff;
            line-height: 4rem;
            margin-right: 0.5rem;
            padding: 0px 1rem;
            &:hover {
              background: #1484f2;
              color: #fff;
              border-radius: 6px;
            }
            img {
              margin: 1rem;
              height: 1.5rem;
            }
            .imgHover {
              display: none;
            }
          }
          .menuItem {
            display: flex;
            align-items: center;
            height: 2.5rem;
            justify-content: center;

            // padding-right: 2rem;
            img {
              margin: 1rem;
              height: 1.5rem;
            }
            span {
              font-size: 1.6rem;
              color: #333;
            }
          }
        }
      }
    }
  }
  .topdo-center {
    z-index: 999 !important;
    .menuDiv {
      float: left;
      padding: 0;
      .menuParent {
        padding: 0 10px !important;
      }
    }
    .menuHeader {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 5rem;
      .menuDiv {
        // float: left;
        // padding: 0 1rem;
        // min-width: 60px;
        border-right: 1px solid #777;

        .menuParent {
          // /deep/.ivu-icon {
          //   display: none;
          // }
          .menuContent {
            display: flex;
            align-items: center;
            height: 3rem;
            img {
              margin: 1rem;
              height: 1.5rem;
            }
          }
          &:hover {
            // background-color: #fff;
            color: #1353c8 !important;
          }
        }
        &:hover {
          // background-color: #fff;
          // color: #1353c8 !important;
        }
      }
      .ivu-menu-light {
        background-color: transparent;
        color: #000;
      }

      .ivu-menu-horizontal.ivu-menu-light:after {
        content: '';
        display: block;
        width: 0%;
        height: 1px;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
    .actived {
      background: rgba(255, 255, 255, 1);
      border-radius: 16px;
      color: #0580ce;
    }
    /deep/.ivu-menu-item-group ::marker {
      width: 0;
      height: 0;
      display: none;
    }
    /deep/ .ivu-menu-item-group-title:before {
      content: '';
      width: 5px;
      height: 14px;
      vertical-align: middle;
      color: #009afa;
      background: #009afa;
      border-radius: 3px;
      margin-right: 5px;
      margin-top: -1px;
      display: inline-block;
    }
    /deep/ .ivu-menu-item-group-title {
      margin-left: 12px;
      padding-left: 13px;
      font-size: 12px;
      color: #009afa;
    }
    /deep/ .ivu-menu-item-group > ul {
      margin-left: 8px;
      margin-top: 3px;
      /deep/ .ivu-menu-item:before  {
        content: '';
        width: 5px;
        height: 5px;
        display: inline-block;
        background-color: #009afa;
        border-radius: 50%;
        vertical-align: middle;
        margin-right: 5px;
      }
    }
    /deep/ .ivu-select-dropdown {
      min-width: 0 !important;
      margin: 16px 0;
      z-index: 99999 !important;
      /deep/.ivu-menu-item {
        padding: 18px 16px 18px 20px;
      }
    }

    .ivu-icon {
      width: 19px;
      height: 19px;
      margin-right: 0px;
      vertical-align: text-bottom;
    }
    .ivu-menu-item-group {
      float: left;
      margin-top: 15px;
    }

    .ivu-menu-horizontal.ivu-menu-light:after {
      content: '';
      display: block;
      width: 0%;
      height: 1px;
      position: absolute;
      bottom: 0;
      left: 0;
    }
    .ivu-menu-horizontal .ivu-menu-submenu .ivu-select-dropdown .ivu-menu-item {
      font-size: 12px !important;
      color: #666666 !important;
    }
    .ivu-menu-horizontal .ivu-menu-submenu .ivu-select-dropdown .ivu-menu-item-disabled {
      color: #c5c8ce !important;
      cursor: not-allowed !important;
    }
    .ivu-menu-light {
      // background-image: url('../../../static/img/web1x/导航栏TOP.png');
      width: 100%;
      // background-color: #64aeeb;
    }

    .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu,
    .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item {
      height: inherit;
      line-height: inherit;
      border-bottom: 1px solid transparent;
      // color: #fff;
      color: #000;
    }
    .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active {
      // background: rgba(255, 255, 255, 1);
      border-radius: 17px;
      color: #2d8cf0 !important;
    }

    .ivu-menu-horizontal .ivu-menu-submenu .ivu-select-dropdown .ivu-menu-item-selected span,
    .ivu-menu-horizontal .ivu-menu-submenu .ivu-select-dropdown .ivu-menu-item-selected span:hover {
      // color: #fff;
      color: #2d8cf0;
      // background: rgba(0, 154, 250, 1);
      opacity: 0.64;
      border-radius: 4px;
      // padding: 4px;
    }

    /deep/.ivu-menu-light {
      background: transparent;
    }

    .ivu-menu-horizontal {
      height: 27px;
      line-height: 27px;
    }

    .ivu-menu-drop-list .ivu-menu-item {
      color: #000 !important;
    }

    /deep/ .ivu-menu-submenu-title {
      font-size: 16px !important;
    }
  }
  .container-top {
    width: 100%;
    padding: 2px 2%;
    height: 30px;
    // background: #f7f7f7;
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow-x: auto;
    overflow-y: auto;

    .top-left {
      width: 10%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .imgurl {
        display: flex;
        align-items: center;
        // width: 5%;
        span {
          font-size: 10px;
          margin-left: 5px;
        }
      }
    }

    .top-right {
      a {
        position: relative;
        line-height: 28px;

        float: left;
        padding: 0 10px;
        font-size: 10px;
        color: #000;

        i {
          display: inline-block;
          width: 100%;
          text-align: center;
          font-style: normal;
          position: absolute;
          top: 100%;
          left: 0;
          z-index: 999;
          color: #000;
          background-color: yellowgreen;
        }
      }

      .span {
        color: #959595;
        line-height: 28px;
        float: left;
      }
    }
  }

  .header-topdo {
    background-size: cover;
    background-repeat: no-repeat;
    // background-attachment: fixed;
    background-image: url('../../../../static/image/home/background.png');
    // position: absolute;
    border-bottom: 1px solid #ccc;
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 999;
    .topdo-left {
      // padding-left: 12px;
      display: flex;
      align-items: center;
      justify-content: start;
      font-size: 20px;
      font-weight: 600;
      color: #000;
      img {
        width: 100%;
        height: 59px;
      }
      span {
        margin-left: 10px;
        color: #000;
      }
    }

    .topdo-right {
      // width: 25%;
      float: right;
      height: 100%;

      .sysinfo {
        width: 50%;

        ul {
          display: inline;

          li {
            float: left;

            img {
              display: block;
              margin: 0 auto;
            }

            span {
              display: block;
            }
          }
        }
      }

      .tool {
        width: 50%;
      }

      .button {
        border-radius: 4px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        position: relative;
        min-width: 105px;
        height: 30px;
        float: right;
        font-size: 14px;
        line-height: 28px;
        // border: 1px solid #00a032;
        // background: #fff;
        // color: #00a032;

        .tip {
          position: absolute;
          top: -2px;
          right: -2px;
          display: inline-block;
          line-height: 16px;
          height: 16px;
          min-width: 16px;
          border-radius: 8px;
          // background-color: #00a032;
          text-align: center;
          font-weight: bold;
          color: #000;
        }

        .pear {
          color: #000;
          cursor: pointer;
        }
      }

      .topdo-right-ul {
        overflow: hidden;
        height: 100%;
        li {
          float: left;
          list-style-type: none;
          margin-right: 15px;
          cursor: pointer;
          height: 100%;
          align-items: center;
          display: flex;
          div {
            display: flex;
            flex-direction: column;
            align-items: center;

            img {
              width: 20px;
              height: 20px;
            }

            span {
              color: #cad6e2;
              font-size: 13px;
            }
          }

          .li-img {
            display: flex;
          }
        }

        .border-right {
          border-right: 2px solid 000;
          // padding-right: 15px;
        }
      }
    }
  }
}

/deep/ ul li {
  list-style: none;
}

.topdo-right {
  height: 100%;
  .sysinfo {
    width: 60%;
    ul {
      display: inline;
      li {
        float: left;
        img {
          display: block;
          margin: 0 auto;
        }
        span {
          display: block;
        }
      }
    }
  }

  .tool {
    width: 50%;
  }

  .button {
    border-radius: 4px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: relative;
    min-width: 105px;
    height: 30px;
    float: right;
    font-size: 14px;
    line-height: 28px;
    // border: 1px solid #00a032;
    // background: #fff;
    // color: #00a032;

    .tip {
      position: absolute;
      top: -2px;
      right: -2px;
      display: inline-block;
      line-height: 16px;
      height: 16px;
      min-width: 16px;
      border-radius: 8px;
      // background-color: #00a032;
      text-align: center;
      font-weight: bold;
      color: #000;
    }

    .pear {
      // background: #fff;
      color: #000;
      cursor: pointer;
    }
  }
  .topdo-right-ul {
    display: flex;
    align-items: center;
    overflow: hidden;
    height: 100%;
    li {
      float: left;
      list-style-type: none;
      // margin-right: 10px;
      cursor: pointer;
      height: 100%;
      align-items: center;
      display: flex;
      div {
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
          width: 20px;
          height: 20px;
        }

        span {
          color: #cad6e2;
          font-size: 13px;
        }
      }

      .li-img {
        display: flex;
      }
    }
    .border-right {
      border-right: 2px solid white;
      // padding-right: 15px;
    }
  }
  .topdo-right-ul /deep/.ivu-btn {
    // padding: 0 5px !important;
  }
}

// 去掉导航栏下划线
/deep/.ivu-menu-horizontal.ivu-menu-light:after {
  background: transparent;
}

/deep/.ivu-form {
  .ivu-form-item-label {
    font-size: 14px !important;
  }
}

/deep/.ivu-form-item-content {
  input {
    font-size: 14px !important;
  }
}

/deep/.ivu-modal-footer {
  border: none;
  text-align: center;
  button {
    font-size: 16px;
    width: 10rem;
    height: 5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/header/outherPage/index.vue